function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { actions as ppcActions } from '../../../reducers/ppc.reducer';
import useHasPermission from '../../../helpers/hooks/useHasPermission';
import AzureBlob from '../AzureBlob.react';
import Card from '../card/Card.react';
import CardHeader from '../card/CardHeader.react';
import CardBody from '../card/CardBody.react';
import Button from '../Button.react';
import Label from '../form/Label.react';
import Input from '../form/Input.react';
import AddImage from '../assets/add-image/AddImage.button';
import Cropper from '../Cropper.react';
var PpcPageBanner = function PpcPageBanner(_ref) {
  var id = _ref.id,
    _ref$banner = _ref.banner,
    banner = _ref$banner === void 0 ? {} : _ref$banner,
    bannerType = _ref.bannerType,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$permission = _ref.permission,
    permission = _ref$permission === void 0 ? null : _ref$permission;
  var dispatch = useDispatch();
  var hasPermission = useHasPermission(permission);
  var _useState = useState(_objectSpread({}, banner)),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var _useState3 = useState({
      visible: false,
      asset: null,
      assetID: null,
      crop: {},
      reCrop: false,
      filename: null
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    cropper = _useState4[0],
    setCropper = _useState4[1];
  useEffect(function () {
    setState(_objectSpread({}, banner));
  }, [banner]);
  var setBanner = function setBanner(key, val) {
    setState(_objectSpread(_objectSpread({}, state), {}, _defineProperty({}, key, val)));
  };
  var getUpdateAction = function getUpdateAction() {
    switch (bannerType) {
      case 'productCategory':
        return ppcActions.productCategory;
      case 'product':
        return ppcActions.product;
      case 'serviceCategory':
        return ppcActions.serviceCategory;
      case 'service':
        return ppcActions.service;
      case 'page':
        return ppcActions.page;
      default:
        return null;
    }
  };
  var getID = function getID() {
    switch (bannerType) {
      case 'productCategory':
      case 'serviceCategory':
        return {
          categoryID: id
        };
      case 'product':
        return {
          productID: id
        };
      case 'service':
        return {
          serviceID: id
        };
      case 'page':
        return {
          pageID: id
        };
      default:
        return {};
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Page Banner"
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement("div", {
    className: "ppc-banner"
  }, (banner === null || banner === void 0 ? void 0 : banner.asset) && /*#__PURE__*/React.createElement(AzureBlob, {
    filename: banner === null || banner === void 0 ? void 0 : banner.filename,
    assetID: banner === null || banner === void 0 ? void 0 : banner.asset
  }), /*#__PURE__*/React.createElement("div", {
    className: "ppc-banner__overlay"
  }), /*#__PURE__*/React.createElement("div", {
    className: "ppc-banner__label"
  }, (banner === null || banner === void 0 ? void 0 : banner.label) || /*#__PURE__*/React.createElement("span", null, "No Label"))), /*#__PURE__*/React.createElement("div", {
    className: "a__btns"
  }, !disabled && !(banner !== null && banner !== void 0 && banner.asset) && /*#__PURE__*/React.createElement(AddImage, {
    blobType: "ppcPageBanner",
    onCrop: function onCrop(data) {
      dispatch({
        type: getUpdateAction(),
        payload: {
          formData: _objectSpread(_objectSpread({}, getID()), {}, {
            blobType: data.blobType,
            assetID: data.assetID,
            crop: data.crop,
            apiID: 'add-image-button'
          }),
          method: 'post',
          route: 'page-banner-assets'
        }
      });
    }
  }), hasPermission && !disabled && (banner === null || banner === void 0 ? void 0 : banner.asset) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    label: "Re-Crop",
    onClick: function onClick() {
      setCropper(_objectSpread(_objectSpread({}, cropper), {}, {
        assetID: state.asset,
        visible: true,
        crop: state.crop,
        reCrop: true,
        filename: state.filename
      }));
    }
  }), /*#__PURE__*/React.createElement(Button, {
    label: "Delete",
    type: "delete",
    requireConfirmation: true,
    icon: "lock-icon@3x.png",
    apiID: "delete-image",
    onClick: function onClick() {
      dispatch({
        type: getUpdateAction(),
        payload: {
          formData: _objectSpread(_objectSpread({}, getID()), {}, {
            apiID: 'delete-image'
          }),
          method: 'delete',
          route: 'page-banner-assets'
        }
      });
    }
  }))), /*#__PURE__*/React.createElement(Label, {
    label: "Label"
  }), /*#__PURE__*/React.createElement(Input, {
    value: state === null || state === void 0 ? void 0 : state.label,
    onChange: function onChange(e) {
      return setBanner('label', e.target.value);
    },
    disabled: disabled
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Alt Tag"
  }), /*#__PURE__*/React.createElement(Input, {
    value: state === null || state === void 0 ? void 0 : state.altTag,
    onChange: function onChange(e) {
      return setBanner('altTag', e.target.value);
    },
    disabled: !(banner !== null && banner !== void 0 && banner.asset) || disabled
  }), !disabled && hasPermission && /*#__PURE__*/React.createElement("div", {
    className: "a__btns"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Update",
    apiID: "banner-details",
    onClick: function onClick() {
      dispatch({
        type: getUpdateAction(),
        payload: {
          formData: _objectSpread(_objectSpread({}, getID()), {}, {
            label: (state === null || state === void 0 ? void 0 : state.label) || '',
            altTag: (state === null || state === void 0 ? void 0 : state.altTag) || '',
            apiID: 'banner-details'
          }),
          method: 'put',
          route: 'page-banner-details'
        }
      });
    }
  })), /*#__PURE__*/React.createElement(Cropper, {
    visible: cropper.visible,
    asset: cropper.asset,
    assetID: cropper.assetID,
    crop: cropper.crop,
    type: "ppcPageBanner",
    onClose: function onClose() {
      return setCropper(_objectSpread(_objectSpread({}, cropper), {}, {
        visible: false
      }));
    },
    onCrop: function onCrop(_ref2) {
      var crop = _ref2.crop,
        assetID = _ref2.assetID;
      dispatch({
        type: getUpdateAction(),
        payload: {
          formData: _objectSpread(_objectSpread({}, getID()), {}, {
            blobType: 'ppcPageBanner',
            crop: {
              x: crop.x,
              y: crop.y,
              w: crop.width,
              h: crop.height
            },
            assetID: assetID,
            filename: state.filename
          }),
          method: 'put',
          route: 'page-banner-assets'
        }
      });
      setCropper({
        visible: false,
        asset: null,
        assetID: null,
        reCrop: false,
        filename: null
      });
    }
  }))));
};
export default PpcPageBanner;